import React from 'react';

export const NoPreview = (): JSX.Element => {
  return <div className="cams-no-preview">No Preview</div>;
};
